import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import IndexForm from '../components/IndexForm';

export default class IndexPage extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    return (
      <div className="container">
        <div className="content">
          <div className="index-left">
            <h1 className="index">Were here for <br/>your cause.</h1>
          </div>
          <hr/>
          <div className="index-right">
            <IndexForm/>
          </div>
        </div>
      </div>
    )
  }
}


IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] },
      filter: { frontmatter: { templateKey: { eq: "blog-post" } }}
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            templateKey
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js